import React from 'react';
import { withTranslation } from 'react-i18next';
import { priceFormatter } from '../../../helpers/formatters';
import NumericInput from '../FormControls/NumericInput';
import CurrencyIcon from '../../../shared/components/Icons/Currency';
import Modal from '../Modal';
import Styled from './styles';
import COLORS from '../../../constants/COLORS';
import transliterate from '../../../helpers/transliterate';
import Currency from '../../../shared/components/Currency';
import useTicketsCountModal from '../../../hooks/useTicketsCountModal';
import { StandingTicketInput } from './StandingTicketInput';
import { StandingTicketsFooter } from './StandingTicketsFooter';

const TicketsCountModal = ({ t }) => {
  const { state, hide, updateCount } = useTicketsCountModal();
  const { count, data, ticket } = state;

  if (!data) return null;

  const price = ticket ? ticket.price : data.price;
  const { standingTicketsController } = window.Widget;
  const standingTickets = standingTicketsController.data.filter(
    (i) => i.fragment.attributes.label === data.label,
  );

  if (standingTickets.length) {
    return (
      <Styled.Wrapper>
        <Modal onClickOverlay={hide}>
          <Styled.Title>{transliterate(data.label)}</Styled.Title>
          {standingTickets.map((standingTicket) => (
            <Styled.Ticket key={standingTicket.id}>
              <Styled.Container>
                <Styled.ItemPrice>
                  <Currency>
                    {priceFormatter(standingTicket.price)}{' '}
                    <CurrencyIcon width={13} height={13} bold fill={COLORS.MARKETPLACE_BLACK} />
                  </Currency>
                  {`/${t('pcs')}`}
                </Styled.ItemPrice>
                <StandingTicketInput data={standingTicket} />
              </Styled.Container>
            </Styled.Ticket>
          ))}
          <StandingTicketsFooter sector={data.label} />
        </Modal>
      </Styled.Wrapper>
    );
  }

  return (
    <Styled.Wrapper>
      <Modal onClickOverlay={hide}>
        <Styled.Title>{transliterate(data.label)}</Styled.Title>
        <Styled.Container>
          <Styled.ItemPrice>
            <Currency>
              {priceFormatter(price)}{' '}
              <CurrencyIcon width={13} height={13} bold fill={COLORS.MARKETPLACE_BLACK} />
            </Currency>
            {`/${t('pcs')}`}
          </Styled.ItemPrice>
          <NumericInput
            min={0}
            max={ticket ? ticket.count : data.count}
            onChange={updateCount}
            value={count}
            isMobile
          />
        </Styled.Container>
        <Styled.Footer>
          {t('total')}
          <Styled.Price dark={!!count}>
            <Currency>
              {priceFormatter(count * price)}{' '}
              <CurrencyIcon
                width={9}
                height={10}
                fill={(count && COLORS.MARKETPLACE_BLACK) || COLORS.MARKETPLACE_DARK_GREY}
              />
            </Currency>
          </Styled.Price>
        </Styled.Footer>
      </Modal>
    </Styled.Wrapper>
  );
};

// @ts-ignore
export default withTranslation()(TicketsCountModal);
